<template>
    <div>
        <CultivationOfTalentsTop />
        <div class="jhCollege">
            <div class="titleStyle">
                <div class="titleFont">建华学堂</div>
                <div class="conentFont">
                    <div class="divide"></div>
                    <span class="enFont">JIANHUA COLLEGE</span>
                    <div class="divide"></div>
                </div>
            </div>
            <div class="colBigDiv">
                <div class="squareDiv">
                    <div class="squareDivTitle">成立时间</div>
                    <div class="squareDivConenteRB"></div>
                    <div class="squareDivConente squareDivConenteRight">
                        2004年成立，为满足建华健康持续发展对人才的迫切需求，集团于2004年1月于中山小榄成立建华学堂。自成立之日起，一直践行“培训、培训、再培训，学习、学习、再学习”的教学理念，为建华的发展壮大培养了大批人才。
                    </div>
                </div>
                <div class="squareDiv">
                    <div class="squareDivTitle">培训体系</div>
                    <div class="squareDivConenteLB"></div>
                    <div class="squareDivConente squareDivConenteLeft">
                        培训分为新人培训、在职培训和干部培养包含：大学生成长计划；骨干特训营、井冈山红色教育；人才梯队育鹰计划等。
                    </div>
                </div>
                <div class="squareDiv">
                    <div
                        class="
                            squareDivConente
                            squareDivConenteRight
                            squareDivConenteRightBom
                        "
                    >
                        2015年3月，新教学楼落成后，培训工作更加规范化、专业化和系统化。目前建华学堂拥有产、学、研一体化的实践教学平台和教学、餐饮、住宿、接车等一体化的后勤保障资源。
                    </div>
                    <div class="squareDivConenteRT"></div>
                    <div class="squareDivTitle">培训设施</div>
                </div>
                <div class="squareDiv">
                    <div
                        class="
                            squareDivConente
                            squareDivConenteLeft
                            squareDivConenteRightBom
                        "
                    >
                        截止至2020年12月兼职讲师574位，累计组织培训班600余期，参训学员3万余人次。
                    </div>
                    <div class="squareDivConenteLT"></div>
                    <div class="squareDivTitle">培训课程</div>
                </div>
                <div class="circularDiv">
                    <img src="@/assets/CultivationOfTalents/centerMiddle.png" />
                </div>
            </div>
            <!-- <div class="jhDescribeFont">
                {{ jhCollegeInfo.description }}
            </div>
            <div class="jhList">
                <div class="jhItem">
                    <img
                        src="@/assets/CultivationOfTalents/establishedTime.png"
                        class="jhItemImg"
                    />
                    <div class="jhItemTitle">成立时间</div>
                    <div class="jhItemContent">2004 年1月</div>
                </div>
                <div class="jhItem">
                    <img
                        src="@/assets/CultivationOfTalents/schoolMotto.png"
                        class="jhItemImg"
                    />
                    <div class="jhItemTitle">校 训</div>
                    <div class="jhItemContent">
                        以教人者教己，在劳力上劳心，学以致用
                    </div>
                </div>
                <div class="jhItem">
                    <img
                        src="@/assets/CultivationOfTalents/slogan.png"
                        class="jhItemImg"
                    />
                    <div class="jhItemTitle">口 号</div>
                    <div class="jhItemContent">
                        不断学习、不断实践、不断总结
                    </div>
                </div>
            </div>
            <div class="jhListLast">
                <img
                    src="@/assets/CultivationOfTalents/lastImg.png"
                    class="jhListLastImg"
                />
                <div class="jhListLastFont">
                    <div class="jhListLastFontDescription">
                        为了践行“以人为本”的企业理念，更好地完善集团公司的人才梯队建设，以重视人、尊重人、提升人为出发点，使公司管理人员和专业技术人员的能力素质能跟上集团快速发展的要求和步伐，特成立建华学堂。建华学堂担负着不断地提升人、培养人的重要使命!
                    </div>
                </div>
            </div> -->
        </div>
        <!-- <div class="collegeIntelligentArchitecture">
            <div class="titleStyle">
                <div class="titleFont">学堂职能架构</div>
                <div class="conentFont">
                    <div class="divide"></div>
                    <span class="enFont">COLLEGE INTELLIGENT ARCHITECTURE</span>
                    <div class="divide"></div>
                </div>
            </div>
            <div class="collegeIntelligentArchitectureList">
                <div
                    class="collegeIntelligentArchitectureListItem"
                    v-for="(item, idx) in collegeIntelligentArchitectureList"
                    :key="idx"
                    :style="{
                        backgroundImage: 'url(' + item.image + ')',
                    }"
                    v-show="idx < 5"
                >
                    <div class="opacityItm">
                        <img :src="item.subImage" class="itemImg" />
                        <div class="itemTitle">{{ item.title }}</div>
                        <div class="itemContent">
                            <div
                                class="contentItem"
                                v-for="(iitem, i) in item.newDescription"
                                :key="i"
                                v-show="i < 5"
                            >
                                {{ iitem }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="environmentIntroduction">
            <div class="titleStyle">
                <div class="titleFont">学堂环境</div>
                <div class="conentFont">
                    <div class="divide"></div>
                    <span class="enFont"
                        >INTRODUCTION TO COLLEGE ENVIRONMENT</span
                    >
                    <div class="divide"></div>
                </div>
            </div>
            <div class="environmentIntroductionList">
                <div class="listItemLeft">
                    <div
                        class="leftItem"
                        v-for="(item, idx) in environmentIntroductionList"
                        :key="idx"
                        :style="{
                            backgroundImage: 'url(' + item.image + ')',
                        }"
                        v-show="idx < 4"
                    >
                        <img :src="item.image" class="itemImg" />
                        <div class="opacityItm">
                            <div class="opacityItmTitle">{{ item.title }}</div>
                        </div>
                    </div>
                </div>
                <div
                    class="listItemRight"
                    v-if="environmentIntroductionList.length > 4"
                >
                    <img
                        :src="environmentIntroductionList[4].image"
                        class="itemImg"
                    />
                    <div class="opacityItm">
                        <div class="opacityItmTitle">
                            {{ environmentIntroductionList[4].title }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CultivationOfTalentsTop from "@/components/CultivationOfTalentsTop.vue";
import { getAction } from "@/api/services";
export default {
    name: "CollegeIsIntroduced",
    components: {
        CultivationOfTalentsTop,
    },
    data() {
        return {
            url: "/jhwlweb/gwweb/cmsArticleCategory/queryAboutusList",
            jhCollegeInfo: {},
            collegeIntelligentArchitectureList: [],
            environmentIntroductionList: [],
        };
    },
    created() {
        this.getInfo();
    },
    methods: {
        getInfo() {
            let that = this;
            let parmas = {
                menuCategory: 280,
            };
            getAction(that.url, parmas).then((res) => {
                if (res.code == 200 && res.success) {
                    res.result.records.forEach((item, idx) => {
                        if (idx == 0) {
                            that.jhCollegeInfo = item;
                        } else if (idx == 1) {
                            let arr = item.cmsArticleList;
                            arr.forEach((item) => {
                                item["newDescription"] =
                                    item.description.split("\n");
                                item.newDescription.pop();
                            });
                            that.collegeIntelligentArchitectureList = arr;
                        } else {
                            that.environmentIntroductionList =
                                item.cmsArticleList;
                        }
                    });
                }
            });
        },
    },
};
</script>
<style lang="less" scoped>
.imgAdaptive {
    width: 100%;
    height: 100%;
}
.bgSet {
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
}
.typeArea {
    max-width: 1100px;
    margin: 0 auto;
}
.titleStyle {
    .typeArea();
    padding-bottom: 80px;
    padding-top: 90px;
    text-align: center;
    width: 100%;
    .titleFont {
        font-family: "阿里巴巴普惠体";
        font-size: 32px;
        line-height: 28px;
        letter-spacing: 2px;
        color: #333333;
    }
    .conentFont {
        margin-top: 8px;
        .divide {
            display: inline-block;
            vertical-align: super;
            width: 20px;
            height: 2px;
            background-color: #0052d9;
        }
        .enFont {
            margin: 0 10px;
            font-family: "微软雅黑";
            font-size: 16px;
            letter-spacing: 0px;
            color: #333333;
            opacity: 0.5;
        }
    }
}
.jhCollege {
    .typeArea();
    .colBigDiv {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        .squareDiv {
            margin: 10px 10px;
            width: 530px;
            height: 250px;
            position: relative;
            overflow: hidden;
            .squareDivTitle {
                width: 100%;
                height: 50px;
                line-height: 50px;
                font-size: 24px;
                background: #0052d9;
                color: white;
                text-indent: 10px;
                font-family: "黑体";
            }
            .squareDivConente {
                font-size: 18px;
                border: 1px solid #999;
                width: 100%;
                height: calc(100% - 50px);
                padding: 20px;
            }
            .squareDivConenteRB {
                position: absolute;
                bottom: -100px;
                right: -100px;
                width: 200px;
                height: 200px;
                background: white;
                border: 1px solid #999;
                border-radius: 50%;
            }
            .squareDivConenteRT {
                position: absolute;
                top: -100px;
                right: -100px;
                width: 200px;
                height: 200px;
                background: white;
                border: 1px solid #999;
                border-radius: 50%;
            }
            .squareDivConenteLB {
                position: absolute;
                bottom: -100px;
                left: -100px;
                width: 200px;
                height: 200px;
                background: white;
                border: 1px solid #999;
                border-radius: 50%;
            }
            .squareDivConenteLT {
                position: absolute;
                top: -100px;
                left: -100px;
                width: 200px;
                height: 200px;
                background: white;
                border: 1px solid #999;
                border-radius: 50%;
            }
            .squareDivConenteLeft {
                padding-left: 100px;
                text-align: right;
            }
            .squareDivConenteRight {
                padding-right: 100px;
                text-align: left;
            }
            .squareDivConenteRightBom {
                padding-top: 60px;
            }
        }
        .circularDiv {
            position: absolute;
            left: calc(50% - 95px);
            top: calc(50% - 95px);
            z-index: 10;
            width: 190px;
            height: 190px;
            border-radius: 50%;
            img {
                width: 100%;
            }
        }
    }
    .jhDescribeFont {
        .typeArea();
        padding: 0 50px;
        text-align: left;
        font-size: 18px;
        letter-spacing: 0px;
        color: #333333;
        margin-bottom: 60px;
    }
    .jhList {
        .typeArea();
        display: flex;
        justify-content: space-between;
        padding-bottom: 25px;
        .jhItem {
            width: 353px;
            height: 200px;
            position: relative;
            .jhItemImg {
                width: 100%;
                height: 100%;
            }
            .jhItemTitle {
                position: absolute;
                left: 0;
                top: 50%;
                margin-top: -14px;
                width: 100%;
                text-align: center;
                font-family: "优选标题黑";
                font-size: 32px;
                line-height: 28px;
                color: #ffffff;
            }
            .jhItemContent {
                opacity: 0;
                position: absolute;
                left: 0;
                top: 50%;
                margin-left: 10%;
                width: 80%;
                text-align: center;
                font-size: 18px;
                color: #ffffff;
            }
        }
        .jhItem:hover {
            background-color: rgba(0, 82, 217, 1);
            .jhItemImg {
                opacity: 0.2;
            }
            .jhItemTitle {
                transition: all 0.3s;
                top: 30%;
            }
            .jhItemContent {
                transition: all 0.3s;
                opacity: 1;
            }
        }
    }
    .jhListLast {
        position: relative;
        .typeArea();
        .jhListLastImg {
            width: 100%;
        }
        .jhListLastFont {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            .jhListLastFontDescription {
                width: 80%;
                font-size: 18px;
                color: #ffffff;
            }
        }
    }
}
.collegeIntelligentArchitecture {
    background-color: #fbfbfb;
    padding-bottom: 80px;
    .collegeIntelligentArchitectureList {
        .typeArea();
        display: flex;
        justify-content: space-around;
        .collegeIntelligentArchitectureListItem {
            position: relative;
            .bgSet();
            width: calc(20% - 16px);
            height: 300px;
            box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.4);
            .opacityItm {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: 100%;
                .itemTitle {
                    font-family: "优设标题黑";
                    font-size: 32px;
                    color: #ffffff;
                    position: absolute;
                    top: 206px;
                    width: 100%;
                    text-align: center;
                }
                .itemContent {
                    position: absolute;
                    width: 100%;
                    text-align: center;
                    top: 107px;
                    opacity: 0;
                    .contentItem {
                        margin-bottom: 10px;
                        font-size: 18px;
                        color: #ffffff;
                    }
                }
                .itemImg {
                    width: 50%;
                }
            }
        }
        .collegeIntelligentArchitectureListItem:hover {
            .opacityItm {
                background: rgba(0, 82, 217, 0.8);
                .itemTitle {
                    transition: all 0.3s;
                    top: 53px;
                }
                .itemContent {
                    transition: all 0.6s;
                    opacity: 1;
                }
                .itemImg {
                    opacity: 0;
                }
            }
        }
    }
}
.environmentIntroduction {
    .typeArea();
    margin-bottom: 100px;
    .environmentIntroductionList {
        display: flex;
        justify-content: space-between;
        .listItemLeft {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;
            flex-grow: 1;
            width: calc(50% - 5px);
            margin-right: 10px;
            .leftItem {
                position: relative;
                width: calc(50% - 5px);
                .itemImg {
                    width: 100%;
                }
                .opacityItm {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .opacityItmTitle {
                        font-family: "优设标题黑";
                        font-size: 32px;
                        color: #ffffff;
                        opacity: 0;
                    }
                }
            }
            .leftItem:nth-child(3),
            .leftItem:nth-child(4) {
                margin-top: 10px;
            }
            .leftItem:hover {
                .opacityItm {
                    background: rgba(0, 82, 217, 0.8);
                    .opacityItmTitle {
                        transition: all 0.3s;
                        opacity: 1;
                    }
                }
            }
        }
        .listItemRight {
            width: calc(50% - 5px);
            position: relative;
            .itemImg {
                width: 100%;
                height: 100%;
            }
            .opacityItm {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                .opacityItmTitle {
                    font-family: "优设标题黑";
                    font-size: 32px;
                    color: #ffffff;
                    opacity: 0;
                }
            }
        }
        .listItemRight:hover {
            .opacityItm {
                background: rgba(0, 82, 217, 0.8);
                .opacityItmTitle {
                    transition: all 0.3s;
                    opacity: 1;
                }
            }
        }
    }
}
</style>
